import { type Theme, type Components } from "@mui/material/styles";

export const dataDisplayCustomizations: Components<Theme> = {
  MuiList: { styleOverrides: { root: { padding: 8 } } },
  MuiListItemButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        minHeight: 44,
        borderRadius: 4,
        "&.Mui-selected": {
          color: theme.palette.primary.main,
          backgroundColor: theme.palette.action.selected,
        },
      }),
    },
  },
  MuiListItemText: {
    styleOverrides: {
      primary: { fontSize: "0.875rem", fontWeight: 500, lineHeight: 1.6 },
      secondary: { fontSize: "0.8125rem", lineHeight: 1.5 },
    },
  },
  MuiListSubheader: {
    styleOverrides: {
      root: { backgroundColor: "transparent", fontWeight: 500 },
    },
  },
  MuiListItemIcon: { styleOverrides: { root: { minWidth: 32 } } },
  MuiChip: {
    defaultProps: { size: "small" },
    styleOverrides: {
      root: ({ theme, ownerState }) => ({
        borderRadius: 4,
        height: ownerState.size === "small" ? 26 : 32,
        fontSize: "0.8125rem",
        fontWeight: 500,
        ...(ownerState.color === "default" && {
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.action.hover,
          borderColor: theme.palette.divider,
        }),
      }),
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: ({ theme }) => ({ borderColor: theme.palette.divider }),
      head: { fontWeight: 600 },
    },
  },
  MuiTablePagination: {
    styleOverrides: {
      actions: { "& .MuiIconButton-root": { width: 40, height: 40 } },
    },
  },
};
